import { render } from "./Bubble.vue?vue&type=template&id=f5e50210&scoped=true&ts=true"
import script from "./Bubble.ts?vue&type=script&lang=ts"
export * from "./Bubble.ts?vue&type=script&lang=ts"

import "./Bubble.scss?vue&type=style&index=0&id=f5e50210&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f5e50210"]])

export default __exports__